module.exports = "//static.hsappstatic.net/ContentUtils/static-1.60430/img/choiceButtons/social-icon-background-shape-rounded.svg"